.callIntroFlowCard {
    overflow-y: auto;
}
